<template>
	<v-card>
		<v-container>
			<v-toolbar-title class="mb-4">Lojas</v-toolbar-title>
			<div class="subtitle-1"> Primária </div>
			<v-row>
				<v-col cols="7" sm="5">
					<SeletorDeLojas
						label="Loja*"
						v-model="irmao.loja"
						:rules="[ obrigatorio ]"
						required
						:disabled="!intersectRoles(authModule.role, 'admin') && !adminPotenciaGuard"
						:return-object="false"
						:potencia="!intersectRoles(authModule.role, 'admin') ? irmao.potencia : undefined"
					/>
				</v-col>
				<v-col cols="5" sm="3">
					<SeletorDeSituacaoDoMacon
						label="Situação*"
						:items="[
							'Regular',
							'Irregular',
							'Placetado',
							'Eterno',
						]"
						v-model="irmao.situacaoDoMacon"
						:rules="[ obrigatorio ]"
						required
						:disabled="!intersectRoles(authModule.role, 'admin') && !adminLojaGuard(irmao.loja) && !adminPotenciaGuard"
					/>
				</v-col>
				<v-col cols="12">
					<v-checkbox
						v-model="irmao.secretarioDeInformatica"
						label="Secretário de informática"
						:disabled="!intersectRoles(authModule.role, 'admin') && !adminLojaGuard(irmao.loja) && !adminPotenciaGuard"
					/>
				</v-col>
				<v-col>
					<SeletorDeCargos
						label="Cargo"
						v-model="irmao.cargoDeAdminDaLoja"
						:disabled="!intersectRoles(authModule.role, 'admin') && !adminLojaGuard(irmao.loja) && !adminPotenciaGuard"
						clearable
						@click:clear="() => $nextTick(() => irmao.cargoDeAdminDaLoja = null)"
					/>
				</v-col>
			</v-row>
			<v-divider />
			<div class="subtitle-1 pt-4"> Secundárias </div>
			<v-row v-for="(loja, indice) in irmao.lojas" :key="indice">
				<v-col cols="7" sm="5">
					<SeletorDeLojas
						v-model="loja.loja"
						:rules="[ obrigatorio ]"
						:disabled="!intersectRoles(authModule.role, 'admin') && !adminPotenciaGuard"
						:return-object="false"
						:potencia="!intersectRoles(authModule.role, 'admin') ? irmao.potencia : undefined"
					/>
				</v-col>
				<v-col cols="5" sm="3">
					<SeletorDeSituacaoDoMacon
						label="Situação*"
						:items="[
							'Regular',
							'Irregular',
							'Placetado',
							'	Eterno',
						]"
						v-model="loja.situacaoDoMacon"
						:rules="[ obrigatorio ]"
						required
						:disabled="!intersectRoles(authModule.role, 'admin') && !adminLojaGuard(loja.loja) && !adminPotenciaGuard"
					/>
				</v-col>
				<v-col>
					<SeletorDeCargos
						label="Cargo"
						v-model="loja.cargoDeAdminDaLoja"
						:disabled="!intersectRoles(authModule.role, 'admin') && !adminLojaGuard(loja.loja) && !adminPotenciaGuard"
						clearable
						@click:clear="() => $nextTick(() => loja.cargoDeAdminDaLoja = null)"
					/>
				</v-col>
				<v-col cols="auto" class="d-flex align-center"
					@click="() => removerLojaSecundaria(indice)"
					v-if="intersectRoles(authModule.role, 'admin') || adminLojaGuard(loja.loja) || adminPotenciaGuard"
				>
					<v-btn icon color="error">
						<v-icon> mdi-delete </v-icon>
					</v-btn>
				</v-col>
			</v-row>
			<v-row v-if="!irmao.lojas.length">
				<v-col class="font-italic"> Nenhuma loja secundária... </v-col>
			</v-row>
			<v-row v-if="intersectRoles(authModule.role, 'admin') || adminPotenciaGuard">
				<v-col cols="12">
					<v-btn block color="primary" text @click="adicionarLojaSecundaria">
						<v-icon left> mdi-plus </v-icon>
						Adicionar Loja Secundária
					</v-btn>
				</v-col>
			</v-row>
		</v-container>
	</v-card>
</template>

<script lang="ts">
export default {
	model: {
		prop: 'irmao',
	},
}
</script>

<script setup lang="ts">
import { computed, PropType } from 'vue'
import { authModule, userModule } from '../../../store'
import { InputIrmao, InputLojaIrmao } from '../../../../common/types/Irmao'
import { obrigatorio } from '../../../shareds/regras'
import { intersectRoles } from '../../../helpers/auth-helpers'
import SeletorDeSituacaoDoMacon from '@/components/SeletorDeSituacaoDoMacon.vue'
import SeletorDeLojas from '@/components/SeletorDeLojas.vue'
import { adminLojaGuard as guardaDeAdminDaLoja } from '../../../shareds/sharedsLoja'
import { adminPotenciaGuard as guardaDeAdminDaPotencia } from '@/shareds/sharedsPotencia'
import SeletorDeCargos from '@/components/SeletorDeCargos.vue'

const props = defineProps({
	irmao: { type: Object as PropType<InputIrmao>, required: true },
})

function adicionarLojaSecundaria() {
	props.irmao.lojas.push(criarLojaSecundaria())
}

function removerLojaSecundaria(indice: number) {
	props.irmao.lojas.splice(indice, 1)
}

const adminLojaGuard = computed(() => (idLoja: string | null) => guardaDeAdminDaLoja(idLoja)(userModule.currentUser))

const adminPotenciaGuard = computed(() => guardaDeAdminDaPotencia(props.irmao.potencia)(userModule.currentUser))

function criarLojaSecundaria(): InputLojaIrmao {
	return {
		tipo: 'Secundária',
		loja: null,
		cargoDeAdminDaLoja: '',
		situacaoDoMacon: 'Regular',
	}
}
</script>
